import CssStyle from "@/module/Form/Resources/CssStyle";
import FapiDiscountCode from "@/module/DiscountCode/DiscountCode";
import { Stripe } from "@stripe/stripe-js";

function isBooleanOrNull(item: any): boolean {
  return item === null || typeof item === "boolean";
}

function isStringOrNull(item: any): boolean {
  return item === null || typeof item === "string";
}

function isObjectOrNull(item: any): boolean {
  return item === null || typeof item === "object";
}

function isNumberOrNull(item: any): boolean {
  return item === null || typeof item === "number";
}

function isCssStyleOrNull(item: CssStyle | null): boolean {
  return item === null || item.hasOwnProperty("enabled");
}

function isFapiDiscountCodeOrNull(item: FapiDiscountCode | null): boolean {
  return item === null || item.id > 0;
}

function isStripeOrNull(item: Stripe | null): boolean {
  return item === null || item.hasOwnProperty("redirectToCheckout");
}

export {
  isBooleanOrNull,
  isStringOrNull,
  isObjectOrNull,
  isNumberOrNull,
  isCssStyleOrNull,
  isFapiDiscountCodeOrNull,
  isStripeOrNull,
};
